import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-basic-cutom-info',
  templateUrl: './edit-basic-cutom-info.component.html',
  styleUrls: ['./edit-basic-cutom-info.component.scss']
})
export class EditBasicCutomInfoComponent implements OnInit {
  form!: FormGroup

  constructor(
    public dialogRef: MatDialogRef<EditBasicCutomInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      name: [this.data?.name ?? '', Validators.required],
      company_id: [this.data?.company_id ?? '', Validators.required],
    })
  }

  save(): boolean | void {
    if(this.form.invalid){
      this.form.markAllAsTouched()
      return false
    }
    this.dialogRef.close(this.form.value)
  }

  closed(){
    this.dialogRef.close()
  }

}
